import { OverlayViewF } from '@react-google-maps/api'
import type { MouseEventHandler } from 'react'
import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import { pinOffSetter } from 'tripPlanner/components/TripMaps/utils'
import { TEARDROP_PIN_HEIGHT } from 'tripPlanner/components/TripMaps/MapElement/Pins/MapSelectItemPin'
import SearchCustomPin from 'tripPlanner/components/TripMaps/MapElement/Pins/SearchCustomPin'
import MapInfoWindow from 'tripPlanner/components/TripMaps/MapElement/MapInfoWindow'
import MapSummaryCard from 'tripPlanner/components/TripMaps/SummaryCards'
import type { MarkerItem } from 'tripPlanner/types/tripItem'
import type { GeoPoint } from 'tripPlanner/types/common'

const StyledClickable = styled(Clickable)`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateX(-50%);
`

const Container = styled.div`
  position: relative;
`

interface Props {
  item: MarkerItem
  position: GeoPoint
  active: boolean
  enableWindow?: boolean
  onSelect: (item: MarkerItem) => void
  onDeselect: () => void
}

function SearchMapMarker({
  active,
  item,
  onDeselect,
  onSelect,
  position,
}: Props) {
  const windowRef = useRef<HTMLDivElement | null>(null)

  const onClick: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (active) {
        onDeselect()
      } else {
        onSelect(item)
      }
    },
    [active, item, onDeselect, onSelect],
  )

  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <OverlayViewF
      zIndex={active ? 999 : -1}
      position={position}
      getPixelPositionOffset={pinOffSetter}
      mapPaneName="overlayMouseTarget"
    >
      <Container ref={ref}>
        <StyledClickable onClick={onClick}>
          <SearchCustomPin isActive={active} />
        </StyledClickable>

        <MapInfoWindow
          ref={windowRef}
          open={active}
          alignment="center"
          position="above"
          style={{ top: -TEARDROP_PIN_HEIGHT * 1.3 }}
        >
          <MapSummaryCard item={item} />
        </MapInfoWindow>
      </Container>
    </OverlayViewF>
  )
}

export default React.memo(SearchMapMarker)
